import { render, staticRenderFns } from "./ClientesComponent.vue?vue&type=template&id=2c8fba8e&scoped=true"
import script from "./ClientesComponent.vue?vue&type=script&lang=js"
export * from "./ClientesComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientesComponent.vue?vue&type=style&index=0&id=2c8fba8e&prod&lang=scss&scoped=true"
import style1 from "./ClientesComponent.vue?vue&type=style&index=1&id=2c8fba8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8fba8e",
  null
  
)

export default component.exports